import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BusinessUnitInfo } from '../../../message-models/business-unit.class';

@Component({
  selector: 'app-business-unit-editor',
  templateUrl: './business-unit-editor.component.html',
  styleUrls: ['./business-unit-editor.component.scss']
})
export class BusinessUnitEditorComponent implements OnInit {
  @Input() businessUnit: BusinessUnitInfo = new BusinessUnitInfo();
  @Input() heading = 'Editing Business Unit';
  @Input() helpText = '';
  @Output() choiceMade: EventEmitter<BusinessUnitInfo> = new EventEmitter<BusinessUnitInfo>();
  submitted = false;
  helpMessage: string = "";
  showingHelp = false;

  constructor(public modalRef: DynamicDialogRef) {
  }

  ngOnInit(): void {
    this.helpMessage = this.helpText
  }

  cancelClicked() {
    this.modalRef.close();
    this.choiceMade.emit(null);
  }

  saveClicked() {
    this.submitted = true;
    if (!this.businessUnit.isValid) {
      return;
    }
    this.modalRef.close();
    this.choiceMade.emit(this.businessUnit);
  }

  helpClicked() {
    this.showingHelp = !this.showingHelp;
  }
}
